const { makeStyles } = require('@material-ui/core')

const initialquestionnaireStyles = makeStyles(theme => ({
   iconQuestionnarie: {
      background: '#F4F7FE',
      padding: '1rem',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '60%',
      height: '20px',
      width: '20px'
   },
   quill: {
      width: '100%'
   },
   questionContainer: {
      paddingBottom: '20px',
      borderBottom: '1px solid red'
   },
   modalButtonsContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      // justifyContent: 'space-evenly',
      gap: '3rem',
      marginTop: '.7rem'
   },
   confirmModalContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1.6rem 3rem',
      gap: '1rem'
   },
   PageContainer: {
      flexDirection: 'column',
      height: '100%',
      padding: theme.spacing(1, 2, 0, 2)
   },
   paper: {
      width: '100%',
      borderTop: '8px solid #3264DC',
      maxWidth: '1200px',

      // padding: theme.spacing(3, 3, 1.5),

      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      // alignItems: 'center',
      // justifyContent: 'center',
      margin: '10px auto'
      // padding: '2rem 3rem'
   },
   paperQuestion: {
      width: '70%',
      // padding: theme.spacing(3, 3, 1.5),
      border: '1px solid #3264DC',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: 10,
      boxShadow: '6px 27px 41px -9px rgba(194,194,194,1)',
      transition: '2s'
   },
   containerInputsQuestion: {
      padding: '1.7rem 0',
      width: '80%',
      transition: '2s'
   },
   containerTitle: {
      display: 'flex',
      flexDirection: 'column',
      gap: '30px',
      width: '70%',
      alignItems: 'center'
   },
   formControl: {
      width: '100%',
      height: '30px',
      minWidth: 120,
      textAlign: 'initial',
      fontSize: '14px'
      // '&:not(:first-child)': {
      //     marginTop: '20px'
      // }
   },
   formControlSelect: {
      width: '100%',
      display: 'flex',
      minWidth: 120,
      gap: '12px',
      justifyContent: 'space-between',
      alignItems: 'center'
      // '&:not(:first-child)': {
      //     marginTop: '20px'
      // }
   },
   formControlQuestion: {
      width: '60%'
   },
   title: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#434969'
   },
   autocomplete: {
      width: '50%',
      padding: '0'
   },
   boxItemSelect: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      // borderRadius: '10px',
      fontSize: '13px',
      width: '100%',
      height: '100%',
      padding: '1rem',
      margin: '0'
      // '&:hover': {
      //     background: '#3264DC0F 0% 0% no-repeat',
      //     color: '#3264DC'
      // }
   },
   selectInput: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      justifyContent: 'space-between'
   },
   paperAutocuplete: {
      padding: '1rem',
      '& .MuiAutocomplete-listbox': {
         '& li': {
            margin: '5px 0',
            borderRadius: '10px',
            '&:hover': {
               background: '#3264DC0F 0% 0% no-repeat',
               color: '#3264DC'
            }
         }
      }
   },
   root: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontSize: '13px'
   },

   listGroupContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      margin: '1.5rem 0'
   },
   inputAnswer: {
      width: '100%'
   },
   boxinputAnswer: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px'
   },
   list: {
      padding: '10px',

      '& li': {
         margin: '5px 0',
         borderRadius: '5px',
         padding: '16px',
         '&:hover': {
            background: '#3264DC0F 0% 0% no-repeat',
            color: '#3264DC'
         }
      }
   },
   NumberTextAnswer: {
      paddingTop: '8px',
      marginEnd: '13px',
      color: '#949494'
   },
   AddQuestion: {
      fontSize: '40px',
      cursor: 'pointer',
      marginStart: '1rem'
      // boxShadow: '0px 6px 6px #00000029',
      // borderRadius: '50%',
   },
   homePageWelcome: {
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(0.5)
   },
   homePageWelcomeMessage: {
      font: 'normal normal 900 22px/29px Roboto',
      letterSpacing: '0.18px',
      color: '#43496A'
   },
   homePageWelcomeMessageUserName: {
      textTransform: 'Capitalize'
   },
   homePageSection: {
      height: '421px'
   },
   homePageSectionLeft: {
      marginBottom: '12px'
   },
   [theme.breakpoints.up('md')]: {
      homePageSections: {
         display: 'flex'
      },
      homePageSection: {
         flex: '0 1 50%'
      },
      homePageSectionRight: {
         paddingLeft: '6px'
      },
      homePageSectionLeft: {
         paddingRight: '6px',
         marginBottom: '0px'
      }
   },

   paperQuestionNull: {
      width: '70%',
      // padding: theme.spacing(3, 3, 1.5),
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: 10,
      boxShadow: '6px 27px 41px -9px rgba(194,194,194,1)',
      transition: '2s'
   },
   paperSelectedAnswer: {
      position: 'relative',
      zIndex: '1000',
      // bottom: '43%',
      // right: '14.5%',
      width: '100%',
      height: '100%',
      // padding: theme.spacing(3, 3, 1.5),
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      boxShadow: '6px 27px 41px -9px rgba(194,194,194,1)',
      transition: '2s'
   },
   displeyNone: {
      display: 'none'
   },
   formControlQuestion: {
      width: '100%'
   },
   title: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#434969'
   },
   autocomplete: {
      width: '50%',
      padding: '0'
   },
   boxItemSelect: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      // borderRadius: '10px',
      fontSize: '13px',
      width: '100%',
      height: '100%',
      padding: '1rem',
      margin: '0'
      // '&:hover': {
      //     background: '#3264DC0F 0% 0% no-repeat',
      //     color: '#3264DC'
      // }
   },
   selectInput: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      justifyContent: 'space-between'
   },
   paperAutocuplete: {
      padding: '1rem',
      '& .MuiAutocomplete-listbox': {
         '& li': {
            margin: '5px 0',
            borderRadius: '10px',
            '&:hover': {
               background: '#3264DC0F 0% 0% no-repeat',
               color: '#3264DC'
            }
         }
      }
   },
   root: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      fontSize: '13px'
   },

   listGroupContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      margin: '1.5rem 0'
   },
   inputAnswer: {
      width: '100%'
   },
   boxinputAnswer: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px'
   },
   list: {
      padding: '10px',

      '& li': {
         margin: '5px 0',
         borderRadius: '5px',
         padding: '16px',
         '&:hover': {
            background: '#3264DC0F 0% 0% no-repeat',
            color: '#3264DC'
         }
      }
   },
   NumberTextAnswer: {
      paddingTop: '8px',
      marginEnd: '13px',
      color: '#949494'
   },
   AddQuestion: {
      // position: 'fixed',
      // right: '3%',
      // bottom: '9%',

      fontSize: '40px',
      cursor: 'pointer'
      // marginStart: '1rem'
      // boxShadow: '0px 6px 6px #00000029',
      // borderRadius: '50%',
   },
   AddQuestionTooltip: {
      position: 'fixed',
      right: '3%',
      bottom: '15%'
   },
   saveButton: {
      // padding: '.5rem',
      borderRadius: '50%',
      width: '34px',
      height: '34px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#1E57E1',
      color: '#F9FAFC',
      fontSize: '12px'
   },
   buttonsDeleteQuestion: {
      position: 'absolute',
      top: '0',
      left: '105%',
      width: '34p0x',
      height: '34px',
      backgroundColor: 'rgba(192, 192, 192, 0.2)',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#3264DC',
      '&:hover': {
         color: '#3264DC'
      }
   },
   saveButtonTooltip: {
      position: 'fixed',
      right: '3%',
      bottom: '10%'
   },
   confirmModalContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1.6rem 3rem',
      gap: '1rem'
   },
   buttonHome: {
      position: 'absolute',
      top: '10',
      left: '10%',
      borderRadius: '100px',
      overflow: 'hidden',
      width: '70px',
      height: '70px',
      marginBottom: -30,
      transition: 'transform .2s',
      '&:hover': {
         transform: 'scale(1.1)',
         cursor: 'pointer'
      }
   },
   buttonAnswer: {
      backgroundColor: '#EDEDED34',
      padding: '.5rem 1rem',
      borderRadius: '8px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1rem',
      cursor: 'pointer',
      '&:hover': {
         backgroundColor: '#37C8461D'
      }
   },
   ActiveAnswer: {
      backgroundColor: '#37C8461D'
   },
   rootPopover: {
      maxHeight: '86%'
   },
   paperPopover: {
      height: 'auto'
   },
   popoverFormContainer: {
      display: 'flex',
      // flex: '1 1 auto',
      width: '237px',
      padding: '1rem',
      flexDirection: 'column',
      gap: '.5rem'
   },
   buttonReadyAnswer: {
      // backgroundColor: '#f4f6fd',
      // textTransform: 'none',
      // color: '#1E57E1',
      // textAlign: 'left',
      '& .MuiButton-label': {
         // textAlign: 'left',
         // justifyContent: 'initial',
         // fontWeight: '400',
         padding: '3rem'
      },
      '& .MuiButton-startIcon ': {
         // textAlign: 'left',
         // justifyContent: 'initial',
         justifySelf: 'flex-start'
      }
   },
   buttonItemCuestionarioPadre: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: 'white',
      padding: '.4rem 1rem',
      borderRadius: '5px',
      color: '#43496A1',
      cursor: 'pointer',
      '&:hover': {
         backgroundColor: '#f4f6fd',
         color: '#1E57E1'
      },
      '&:focus': {
         backgroundColor: '#f4f6fd',
         color: '#1E57E1'
      }
   },
   buttonItemCuestionario: {
      backgroundColor: 'white',
      padding: '.8rem',
      borderRadius: '5px',
      color: '#43496A1',
      cursor: 'pointer',
      '&:hover': {
         backgroundColor: '#f4f6fd',
         color: '#1E57E1'
      }
   }
}))

export default initialquestionnaireStyles
